<template>
  <div class="app-container">
    <BjRouteTabs :route-list="ORDER_ABNORMAL_FIVE_ROUTE_LIST" />
    <BjPage ref="BjPage" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :serial="serial" :selection="selection" :before-reset-search="beforeResetSearch" @handleSelectionChange="handleSelectionChange" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @header-contextmenu="SortableTable.handleHeaderContextmenu">
      <template v-slot:baseForm>
        <BjSelectChannelStore :span="colSpan" :query-params="queryParams" :query-props="['channel', 'storeIdList']" multiple />
        <el-col :span="colSpan">
          <el-form-item :label="$t('OrderShortageManagement.Order')" prop="orderNo">
            <BjInput v-model="queryParams.orderNo" :placeholder="$t('orderNewPatch.order')" @keyup.enter.native="handleQuery" />
          </el-form-item>
        </el-col>
        <el-col :span="colSpan">
          <el-form-item :label="$t('OrderShortageManagement.party')">
            <BjDateRangePicker v-model="queryParamsTime_order" :placeholder="$t('OrderShortageManagement.party')" />
          </el-form-item>
        </el-col>
        <!-- 判断isShow是否存在，存在就是客户端，客户端不展示此项 -->
        <el-col v-if="!isShow" :span="colSpan">
          <el-form-item :label="$t('billingPage.CustomerName')" prop="receiverName">
            <BjSelectLov v-model="queryParams.cusId" :option-list="customerList" :placeholder="$t('customerNameText')" />
          </el-form-item>
        </el-col>
      </template>
      <template v-slot:tableOperation>
        <el-col>
          <BjFrontendExport
            class="main-btn"
            type="primary"
            :label-list="labelList"
            :rows="selectedRows"
            file-name="Order out of stock.csv"
          />
          <el-button class="main-btn" type="primary" @click="onExportSKU">{{ $t('exportText') }}SKU</el-button>
          <el-button type="primary" @click="cancelOrder">{{ $t('bulkDelCancelText') }}</el-button>
          <el-button type="primary" @click="reallocate">{{ $t('orderNewPatch.Reprocess') }}</el-button>
        </el-col>
      </template>

      <template v-slot:tableColumn>
        <template v-for="(col, index) in dropCols">
          <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
            <template slot-scope="scope">
              <template v-if="false" />
              <template v-else-if="col.prop == 'cusId'">{{ customerList.bjGet(scope.row.cusId) }}</template>
              <template v-else-if="col.prop === 'outerOrderNo'">
                <span>{{ scope.row.webReference }}</span>
                <BjCopyIcon :copy="scope.row.webReference" />
              </template>
              <template v-else-if="col.prop === 'orderTime'">
                <span>{{ scope.row[col.prop] | timeOptimization }}</span>
              </template>
              <template v-else-if="col.prop === 'creationDate'">
                <span>{{ scope.row[col.prop] | timeOperateTwoHour }}</span>
              </template>
              <template v-else-if="col.prop === 'shippingMethod'">
                <el-tag v-if="['CUSTOMER MANUAL', 'CSG MANUAL', 'PICKUP'].includes(scope.row[col.prop])" type="success">{{ scope.row[col.prop] }}</el-tag>
                <span v-else>{{ scope.row[col.prop] }}</span>
              </template>
              <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            <template #header>
              {{ $t('operationText') }}
              <el-tooltip placement="top">
                <div slot="content">{{ $t('InternalOrder.ps1') }}</div>
                <i class="el-icon-question" style="color: #082dc3;"></i>
              </el-tooltip>
            </template>
            <template slot-scope="props">
              <el-button type="text" class="edit-btn" @click="onView(props.row)">{{ $t('viewText') }}</el-button>
              <el-dropdown v-hasDropdownChildren @command="command($event, props.row)">
                <span class="el-dropdown-link">{{ $t('AccountManagement.common.operate') }}<i class="el-icon-arrow-down el-icon--right" /></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="edit">{{ $t('editText') }} </el-dropdown-item>
                  <el-dropdown-item command="cancel"> {{ $t('cancelText') }} </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </template>
      </template>
    </BjPage>
  </div>
</template>
<script>
import pageMiXin from '@/utils/page-mixin.js';
import { orderApi } from '@/api';
import { downloadBlob } from '@/utils/index';
import { ORDER_ABNORMAL_FIVE_ROUTE_LIST} from '@/utils/constants';
import { timeFilters } from '@/filters';

const sessionTimeOptions = { isSession: true, dateFormat: 'DD/MM/YYYY HH:mm' };

export default {
  name: 'BusinessAbnormalOrderOUTOFSTOCK',
  mixins: [pageMiXin],
  data() {
    return {
      colSpan: 4,
      ORDER_ABNORMAL_FIVE_ROUTE_LIST,
      queryApi: orderApi.getInternalStockoutPage, //
      // 查询参数
      queryParamsTime_order: [],
      queryParams: {
        cusId: this.$store.getters.cusId || null,
        orderNo: null,
        // 时间
        orderStartTime: null,
        orderEndTime: null,
      },
      labelList1: [
        { label: this.$t('billingPage.CustomerName'), prop: 'cusId', isCheck: true, disabled: false, width: '100', export: { roles: ['admin'], options: () => this.customerList } },
        { label: this.$t('OrderShortageManagement.form.number'), prop: 'outerOrderNo', isCheck: true, disabled: false, width: 145, export: { prop: 'webReference' } },
        { label: this.$t('OrderShortageManagement.form.channel'), prop: 'channelTypeMeaning', isCheck: true, disabled: false },
        { label: this.$t('OrderShortageManagement.form.Sales'), prop: 'storeName', isCheck: true, disabled: false },
        { label: this.$t('orderNewPatch.Ordered'), prop: 'orderTime', isCheck: true, disabled: false, export: { dateFormat: 'DD/MM/YYYY HH:mm' } },
        { label: this.$t('orderNewPatch.Created'), prop: 'creationDate', isCheck: true, disabled: false, export: { formatter: value => timeFilters(value, sessionTimeOptions) } },
        { label: this.$t('InternalOrder.form.Product'), prop: 'goodsQuatity', isCheck: true, disabled: false, width: '90'},
        { label: this.$t('orderNewPatch.Shipping'), prop: 'shippingMethod', isCheck: true, disabled: false},
        { label: this.$t('InternalOrderListcompent.name'), prop: 'receiverName', isCheck: true, disabled: false},
        { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150},
      ],

      ids: [],
      id: null,
    };
  },
  computed: {
    isShow() {
      return !!this.$store.getters.cusId;
    },
    labelList() {
      return this.isShow
        ? this.labelList1.filter(item => item.prop !== 'cusId')
        : this.labelList1;
    },
  },
  watch: {
    queryParamsTime_order(v) {
      this.queryParams.orderStartTime = (v || [])[0];
      this.queryParams.orderEndTime = (v || [])[1];
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 查看
    onView(row) {
      // 内部订单详情页
      this.$router.push({
        name: 'BusinessOrderInternalViewCSG',
        query: { id: '', code: encodeURIComponent(row.innerOrderNo), type: 'edit', status: 4, orderHandleStatus: row.orderHandleStatus },
      });
    },
    command(text, row) {
      switch (text) {
        case 'edit':
          // 内部订单编辑页
          this.$router.push({
            name: 'BusinessOrderInternalEditCSG',
            query: { innerOrderNo: row.innerOrderNo },
          });
          break;
        case 'cancel':
          this.onDelete(row);
          break;
      }
    },
    // 行内 取消订单
    onDelete(item) {
      this.$confirm(this.$t('toast.deletionConfirmationText'), this.$t('toast.hintText'), {
        confirmButtonText: this.$t('toast.okText'),
        cancelButtonText: this.$t('toast.cancelText'),
        type: 'warning',
      })
      .then(() => {
        // 如果是缺货订单4，调用内部订单取消接口；
        orderApi.cancelInternalOrder({ innerOrderNo: item.innerOrderNo }).then(res => {
          if (res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.reFresh();
            }, 500);
          }
        });
      });
    },
    // 重新预占
    reallocate() {
      this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
        if (!this.selectedRows.length) {
          orderApi['rePreempOutOfStock']([]).then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
          });
        } else {
          const innerOrders = this.selectedRows.map(item => item.innerOrderNo);
          orderApi['rePreempOutOfStock'](innerOrders).then(res => {
            if (!res.failed) {
              this.msgSuccess(this.$t('toast.operationSuccessText'));
              setTimeout(() => {
                this.reFresh();
              }, 500);
            }
          });
        }
      }).catch(() => {});
    },
    // 批量取消订单按钮
    async cancelOrder() {
        if (!this.selectedRows.length) {
          this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
          return;
        }
        this.$confirm(this.$t('InternalSalesOrderDetails.want')).then(() => {
            let promise = Promise.resolve();
            this.selectedRows.forEach((item) => {
              promise = promise.then(() => {
                return new Promise(resolve => {
                  orderApi.cancelInternalOrder({ innerOrderNo: item.innerOrderNo }).then(res => {
                    if (res.failed === false) {
                      resolve();
                    }
                  });
                });
              });
            });
            return promise.then(() => {
              this.$message.success(this.$t('toast.operationSuccessText'));
              this.reFresh();
            });
        });
    },
    async onExportSKU() {
      if (!this.selectedRows.length) {
        this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
        return;
      }
      const Ids = [];
      const res = await orderApi.exportStockout({exportType: 'COLUMN'});
      if (res.children.length > 0) {
          res.children.forEach(item => Ids.push(item.id));
          let outerOrderNoList = [];
          this.selectedRows.forEach(item => outerOrderNoList.push(item.innerOrderNo));
          outerOrderNoList = outerOrderNoList.join(',');
          orderApi.exportStockout2({
            innerOrderIds: outerOrderNoList,
            ids: Ids.join(','),
            fillerType: 'single-sheet',
            exportType: 'DATA'
          }).then(res => {
            if (!res.failed) {
              downloadBlob(res, 'Order out of stock.xlsx');
              this.$refs.BjPage.onResetQuery();
            }
          });
      }
    },
    /** 重置按钮操作 */
    beforeResetSearch() {
      this.queryParamsTime_order = null;
      this.queryParams.storeIdList = null;
      this.queryParams.cusid = this.$store.getters.cusId || null;
      return new Promise(resolve => {
        resolve();
      });
    },
  },
};
</script>
<style scoped>
::v-deep .bj-page .el-form-item__label{
  display: none;
}
</style>
